import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import ticketingSettingsReducer from '../reducers/ticketingSettingsReducer';

const configureStore = (railsProps) => (
  createStore(ticketingSettingsReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
